import React from 'react';

import { UiTypography } from '@/components/ui/Typography';

interface TitleProps {
  removeDialogueReferences: boolean;
  isLure?: boolean;
  titleStyle: React.ComponentType<React.PropsWithChildren>;
  withPromoCode?: boolean;
}

export const getTitleWithDialogue = ({
  removeDialogueReferences,
  isLure = false,
  titleStyle: TitleStyle,
  withPromoCode = false,
}: TitleProps) => {
  if (withPromoCode) {
    if (isLure) {
      return (
        <TitleStyle>
          Your{' '}
          <UiTypography variant="inherit" color="gradient" component="span">
            Сustom Super Lure AI
          </UiTypography>{' '}
          Plan is ready!
        </TitleStyle>
      );
    }
    return removeDialogueReferences ? (
      <TitleStyle>
        Your Сustom{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          Super Plan
        </UiTypography>{' '}
        is ready!
      </TitleStyle>
    ) : (
      <TitleStyle>
        Your Сustom{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          Super Dialogue Plan
        </UiTypography>{' '}
        is ready!
      </TitleStyle>
    );
  }

  if (isLure) {
    return (
      <TitleStyle>
        Your{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          Сustom Super Lure AI
        </UiTypography>{' '}
        Plan is ready!
      </TitleStyle>
    );
  }

  return removeDialogueReferences ? (
    <TitleStyle>
      Your{' '}
      <UiTypography variant="inherit" color="gradient" component="span">
        Сustom Super
      </UiTypography>{' '}
      Plan is ready!
    </TitleStyle>
  ) : (
    <TitleStyle>
      Your{' '}
      <UiTypography variant="inherit" color="gradient" component="span">
        Сustom Super Dialogue
      </UiTypography>{' '}
      Plan is ready!
    </TitleStyle>
  );
};
